// Central role definitions for the whole app.
// This file is the single source of truth — never hard-code role strings elsewhere.

// The four roles supported by the platform.
export const ROLES = {
  ADMIN: "admin",
  MANAGER: "program_manager",
  FUNDER: "funder",
  VENTURE: "venture",
};

// Human-readable labels for display in the UI (e.g. sidebar footer).
export const ROLE_LABELS = {
  [ROLES.ADMIN]: "Administrator",
  [ROLES.MANAGER]: "Program Manager",
  [ROLES.FUNDER]: "Funder / Partner",
  [ROLES.VENTURE]: "Venture / Entrepreneur",
};

// Permission strings each role is allowed to perform.
// Used by `hasPermission()` in AuthContext to gate UI / actions.
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    "read",
    "write",
    "delete",
    "manage_users",
    "view_all",
    "export",
  ],
  [ROLES.MANAGER]: ["read", "write", "view_all", "export"],
  [ROLES.FUNDER]: ["read", "view_aggregate"],
  [ROLES.VENTURE]: ["read_own", "write_own"],
};

// After login (or when an unauthorised role hits a route they don't own),
// we redirect them to their "home" workspace.
export const ROLE_HOME_ROUTES = {
  [ROLES.ADMIN]: "/admin/dashboard",
  [ROLES.MANAGER]: "/manager/dashboard",
  [ROLES.FUNDER]: "/funder/dashboard",
  [ROLES.VENTURE]: "/venture/dashboard",
};
